// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--2_a-X","titleWrap":"styles-module--titleWrap--3sYi4","block0":"styles-module--block0--1kyFg"};